import imgOne from "../assests/Images/business-strategy-success-target-goals-min.jpg"
import imgTwo from "../assests/Images/HIRE-THE-NEXT-CANDIDATE-.jpg"
import imgThree from "../assests/Images/Aspiring_minds.png"
import imgFour from "../assests/Images/Lets-Stay-in-Touch-with-Aspiring-MIND.jpg"
import { FaArrowRight } from "react-icons/fa";
import { GiPlanetCore } from "react-icons/gi";
import { FaBrain } from "react-icons/fa";
import { FaWineGlass } from "react-icons/fa";
import { FaHandHoldingHeart } from "react-icons/fa";
import { MdPunchClock } from "react-icons/md";
import { GoPersonFill } from "react-icons/go";
import { MdMarkEmailUnread } from "react-icons/md";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { useInView } from "react-intersection-observer";
import WaveEffect from "../Components/WaveEffect";
import { GiFlatStar } from "react-icons/gi";
import coreStrength_icon from '../assests/Images/core-strength_Icon.png'
import { FaDiamond } from "react-icons/fa6";
import { CiMail } from "react-icons/ci";
import { GiCoffeeCup } from "react-icons/gi";


const AspiringMinds = () => {

  return (
    <>
      <Navbar />
      <div className='bg-cover bg-center h-[75vh] lg:h-[75vh] md:h-[500px] sm:h-[400px] ' style={{ backgroundImage: `url(${imgOne})` }}>
        <div className='h-full  bg-black bg-opacity-60 w-full flex flex-col justify-center items-center '>
          <h1 className="text-white text-4xl lg:text-6xl font-bold leading-tight">
            Aspiring MIND
          </h1>
        <div className='h-1  mt-4 w-20 bg-white' />
          <p className='text-center xl:text-xl w-5/6 text-white'>Reliable & Cost Efficient Recruitment Agency Based On Los Angeles</p>
        </div>
      </div>

      <div className="w-full flex flex-col items-center justify-center text-center gap-3 xl:mt-16 my-10">
        <h1 className="text-4xl font-bold text-gray-900 leading-tight">
          Aspiring <span className="text-primary">MIND</span>
        </h1>

        <p className="max-w-3xl text-gray-600">
          Aspiring MIND is a like-minded community of Gen Y Emotional Champions created by a strong Coach and Peer level networking.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 place-items-center px-3 md:px-10 md:mt-10">
        <div className="">
          <div class="inline-flex items-center w-fit rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent  mb-4 bg-red-100 text-red-700" data-v0-t="badge">FIND OUR EMPLOYEES</div>
          <h2 class="text-2xl font-bold text-gray-900 mb-6">Hire Your Next Candidate On PPT</h2>
          <div className="flex flex-col gap-y-4">
            <div class="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
              </svg>
              <span class="text-gray-700">A Community for GIG Economy</span>
            </div>
            <div class="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
              </svg>
              <span class="text-gray-700">Entry to community voluntary. No membership drive.</span>
            </div>
            <div class="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
              </svg>
              <span class="text-gray-700">Voluntary professional contribution, knowledge and experience sharing among community of mutual interest.</span>
            </div>
            <div class="flex items-start space-x-3">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
              </svg>
              <span class="text-gray-700">Members are invited to Community celebrations</span>
            </div>
          </div>

          <div class="mt-8 p-4 bg-gray-50 rounded-lg">
            <div class="flex items-center space-x-2 mb-2">
              <div class="w-12 h-12  rounded-full flex items-center justify-center">
                <img src={coreStrength_icon} alt=""/>
              </div>
              <span class="font-semibold md:text-2xl text-gray-900">Our core strength</span>
            </div>
            <p class="text-sm text-gray-600">Built on core of Gen Y through our Connect</p>
          </div>
        </div>

        <div className="hidden md:flex">
          <img src={imgTwo} alt=""/>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 place-items-center gap-12 px-3 md:px-10 ">
        <div>
          <img src={imgThree} alt=""/>
        </div>

        <div className="flex flex-col justify-start items-start gap-y-5 ">
          <div className="flex items-center gap-3 group border-b w-full pb-2 border-b-red-200">
            <FaBrain className="text-primary text-4xl group-hover:text-black"/>
            <h1 className="text-lg">Enabling mind change</h1>
          </div>

          <div className="flex items-center gap-3 group border-b w-full pb-2 border-b-red-200">
            <FaWineGlass className="text-primary text-4xl group-hover:text-black"/>
            <h1 className="text-lg">Managing Life event Transitions</h1>
          </div>

          <div className="flex items-center gap-3 group border-b w-full pb-2 border-b-red-200">
            <FaDiamond className="text-primary text-4xl group-hover:text-black"/>
            <h1 className="text-lg">Preparing for acceptance of reality</h1>
          </div>

          <div className="flex items-center gap-3 group">
            <FaHandHoldingHeart className="text-primary text-8xl md:text-4xl group-hover:text-black"/>
            <h1 className="text-lg">Creating a Young Coach network for Story Telling, Sharing, Caring and Holding</h1>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-col items-center justify-center text-center gap-3 xl:mt-20 my-10">
        <h1 className="text-4xl font-bold text-gray-900 leading-tight">
          Services <span className="text-primary">Offerings</span>
        </h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-7 md:p-10 md:mt-5 p-5">
        <div className="w-full flex flex-col gap-y-6">
          <h1 className="text-red-700 text-2xl font-semibold text-center">Connect</h1>
          <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-fit p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm w-fit">Creating a space of launching emotionally</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm w-fit">One to one interaction</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm w-fit">No interest both side purely voluntary</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm w-fit">Create an interest to share with peers</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm w-fit">Willingness to be part of Network</p>
            </div>
          </div>
        </div>

         <div className="w-full flex flex-col gap-y-6">
          <h1 className="text-red-700 text-2xl font-semibold text-center">Network</h1>
          <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Multi layer Connect</p>
            </div>
          </div>

         <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">5 Combine Session</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">5 Individual Session</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Check Back periodicity and onward layer Management</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Impact measurement</p>
            </div>
          </div>
        </div>

         <div className="w-full flex flex-col gap-y-6 ">
          <h1 className="text-red-700 text-2xl font-semibold text-center">Investment</h1>

          <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Willingness to engage with Coachee</p>
            </div>
          </div>
          <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Bring seriousness</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Relating skill</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Vulnerability</p>
            </div>
          </div>

           <div className="rounded-lg bg-card shadow-2xs border border-gray-200 hover:shadow-md transition-shadow">
            <div class="flex items-start space-x-3  w-auto p-4">
              <div class="w-2 h-2 bg-red-600 rounded-full mt-2 "></div>
              <p class="text-gray-700 text-sm">Conviction of change and self impact and reflection</p>
            </div>
          </div>
        </div>
      </div>
    
        <section class="py-16 bg-red-600 px-5  md:px-10 max-w-fit">
            <div class="grid md:grid-cols-3 gap-8 text-white">
              <div class="text-center">
                <div class="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-share2 w-8 h-8 text-red-600"><circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line><line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line></svg>
                </div>
                <h3 class="text-xl font-bold mb-4">Sharing</h3>
                <ul class="text-md space-y-2 text-left">
                  <li>• Share what you are, your Stories</li>
                  <li>• Increase your network by helping out of the way as you will get an opportunity for exploration</li>
                  <li>• Increase your moods listening for many others</li>
                  <li>• Unselfish Engagement</li>
                </ul>
              </div>
              <div class="text-center">
                <div class="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart w-8 h-8 text-red-600"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"></path></svg>
                </div>
                <h3 class="text-xl font-bold mb-4">Caring</h3>
                <ul class="text-md space-y-2 text-left">
                  <li>• Empathetic</li>
                  <li>• Able to touch</li>
                  <li>• Reflect with other fellow members</li>
                  <li>• Compromise and Celebrate the small moments of success</li>
                </ul>
              </div>
              <div class="text-center">
                <div class="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield w-8 h-8 text-red-600"><path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path></svg>
                </div>
                <h3 class="text-xl font-bold mb-4">Holding</h3>
                <ul class="text-md space-y-2 text-left">
                  <li>• When you want to cry, don't cry; find out a reason, you must cry for some one</li>
                  <li>• Respect others like Mentors, with folded hand and love them</li>
                  <li>• Get help from some one 1 heart and apply that</li>
                </ul>
              </div>
            </div>
        </section>

        <section className="py-16 px-10 flex md:flex-row flex-col justifu-center items-center gap-10">
          <div>
            <div>
              <h1 className="text-primary text-2xl font-semibold">Let's Stay in Touch with Aspiring MIND</h1>
            </div>
            <div className="flex flex-col gap-3 mt-5">
              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">Its’ your Mind, you need to ignite.</span>
              </div>

              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">It’s your Network, you need to maintain.It’s your Karma, you need to set the directions.</span>
              </div>

              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">Aspiring MIND will work with you, Support you and Respect your Emotional programs.</span>
              </div>
            </div>

            <div className="mt-8">
              <h1 className=" text-2xl font-semibold">How to become a Good Human being and a responsible Citizen</h1>

              <div className="flex flex-col gap-3 mt-5">
              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">In your Network, you need to maintain it your future, you need to set the directions</span>
              </div>

              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">You are a Champion of Society</span>
              </div>

              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">You need to create more Champions</span>
              </div>
              <div class="flex items-start space-x-3">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-target w-5 h-5 text-red-600 mt-1 flex-shrink-0">
                  <circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>
                </svg>
                <span class="text-gray-700">If you will come one will know</span>
              </div>
            </div>
            </div>
          </div>

          <div>
            <img src={imgFour} alt=""/>
          </div>

        </section>

        <section className="">
          <div className="grid md:grid-cols-4 gap-8 p-3 md:p-10">
            <div className="rounded-lg bg-card text-card-foreground shadow-2xs border border-gray-200">
              <div class="flex flex-col space-y-1.5 p-6">
                <h3 class="text-2xl font-semibold leading-none tracking-tight text-red-600">Time</h3>
              </div>
              <div class="p-6 pt-0">
                <p class="text-sm text-gray-700">At your Convenience for 2 Hours inclusive warm up sessions</p>
              </div>
            </div>

            <div className="rounded-lg bg-card text-card-foreground shadow-2xs border border-gray-200">
              <div class="flex flex-col space-y-1.5 p-6">
                <h3 class="text-2xl font-semibold leading-none tracking-tight text-red-600">Investment</h3>
              </div>
              <div class="p-6 pt-0">
                <p class="text-sm text-gray-700">Zero from your end, only Time and Mind</p>
              </div>
            </div>

            <div className="rounded-lg bg-card text-card-foreground shadow-2xs border border-gray-200">
              <div class="flex flex-col space-y-1.5 p-6">
                <h3 class="text-2xl font-semibold leading-none tracking-tight text-red-600">Promise</h3>
              </div>
              <div class="p-6 pt-0">
                <p class="text-sm text-gray-700">Not to change the proceedings of the session unless you are conducting the session as a facilitator on behalf of Aspiring MIND</p>
              </div>
            </div>

            <div className="rounded-lg bg-card text-card-foreground shadow-2xs border border-gray-200">
              <div class="flex flex-col space-y-1.5 p-6">
                <h3 class="text-2xl font-semibold leading-none tracking-tight text-red-600">Commitment</h3>
              </div>
              <div class="p-6 pt-0">
                <p class="text-sm text-gray-700">To honour and respect the time</p>
              </div>
            </div>
          </div>
        </section>
      
      <Footer />
    </>
    )
}

export default AspiringMinds
